import { PHONE_ERROR, PHONE_SUCCESS } from './action-types'

const middleware = () => next => action => {
  switch (action.type) {
    case PHONE_ERROR: {
      if (action.meta.status === 404) {
        action.type = PHONE_SUCCESS
      }
      return next(action)
    }
    default: {
      return next(action)
    }
  }
}

export default middleware
